/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
 export const getRandomInt = (min: number, max: number): number => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const getRandomIntMaxTenk = (): number => {
    return getRandomInt(1, 10000);
}

export const parseNumeric = (value: string | null): number | null => {
    if (value == null) {
        return null;
    }

    const numericValue = Number(value);
    return !isNaN(numericValue) ? numericValue : null;
}

export const stripNonNumeric = (value: string): string => {
    return value.replace(/\D/g, ''); // Remove all non-numeric characters
};